import React from 'react';

/* A pseudo radio container that toggles between choices */
class RadioSelection extends React.Component {
  constructor( props ) {
    super( props );
    // Selects the first option as the default, if not passed down through
    // props.default
    let df = 0;

    if( this.props.defaultOption !== undefined && this.props.defaultOption !== '' && this.props.defaultOption !== null ){
      df = this.props.defaultOption;
    }

    // RadioSelection does not allow for Booleans to be supplied as the
    // default value.
    if( typeof( df ) === 'boolean' ){
      df = df === true ? 1 : 0;
    }

    this.state = {
      options: this.props.options === undefined ? [] : this.props.options,
      selected: '',
      def_option: this.props.defaultOption,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.selectElement = this.selectElement.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  /* Alters the state on new props being passed down */
  componentWillReceiveProps( nextProps ) {
    this.setState( {
      options: nextProps.options,
      def_option: nextProps.defaultOption
    } );
  }

  /* Clicks element on and off */
  selectElement( e ){

    if( this.state.selected !== e ){
    // Sets the selected index
      this.setState( {
        selected: e
      } );
    }


    // Compliant with the onChange of ListContainer
    if( this.props.onChanged !== undefined ) {
      let payload = {target: {value: e}};
      this.props.onChanged( payload );
    }
  }

  /* Renders the component */
  render(){

    if( this.state.hasError === false ) {
      // The default option, passed down from the parent
      let default_value = this.state.def_option;
      if( default_value !== undefined ) {
        return (
          <div className={'selection-radio-container'}>
            {
              this.state.options.map( ( i ) => <div key={'rbdiv_' + i.value} style={{'paddingTop': '5px'}}>
                <span className={'selection-radio-span'}
                  onClick={ () => this.selectElement( i.value ) }>
                  <input className={'selection-radio-span-radio-button'} type="radio" value={i.text} checked={i.value === default_value}
                    onChange={() => this.selectElement( i.value ) }/>
                  <span className={'selection-radio-span-radio-label'}>{i.text}</span>
                </span>
              </div> )
            }
          </div>
        );
      } else {
        return ( <span></span> );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default RadioSelection;



// WEBPACK FOOTER //
// ./src/presentation/RadioSelection.js